import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 */


import { action, observable, runInAction } from 'mobx';
import { StoreName } from '../StoreName';
import { BaseStore } from '../BaseStore';
import { LoadingState } from '../../api/LoadingState';
import { SupplierLayer } from '../../transportLayers/supply/SupplierLayer';
/**
 * This store obtaining data of price zones.
 */

export var SupplierStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(SupplierStore, _BaseStore);

  function SupplierStore() {
    var _this;

    _classCallCheck(this, SupplierStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierStore).apply(this, arguments));
    _this.name = StoreName.Supplier;
    _this.errorStore = _this.rootStore.getStore(StoreName.Error);
    _this.productStore = _this.rootStore.getStore(StoreName.Product);
    _this.supplierLayer = new SupplierLayer();
    _this.loadingState = LoadingState.Pending;
    _this.list = new Map();
    return _this;
  }

  _createClass(SupplierStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.supplierLayer.findAll().then(function (suppliers) {
        suppliers.forEach(function (supplier) {
          if (supplier.id) {
            runInAction(function () {
              _this2.list.set(supplier.id, supplier);
            });
          }
        });
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  }, {
    key: "getManyByIds",
    value: function getManyByIds(ids) {
      var _this3 = this;

      return this.supplierLayer.filter({
        ids: ids
      }).then(function (suppliers) {
        suppliers.forEach(function (supplier) {
          if (supplier.id) {
            runInAction(function () {
              _this3.list.set(supplier.id, supplier);
            });
          }
        });
        return _this3.list;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  }]);

  return SupplierStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Number)], SupplierStore.prototype, "loadingState", void 0);

__decorate([observable, __metadata("design:type", Map)], SupplierStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], SupplierStore.prototype, "getAll", null);